<template>
  <table class="table">
    <thead>
    <tr>
      <th>Document</th>
      <th class="compact">Aangemaakt op</th>
      <th class="compact">Grootte</th>
    </tr>
    </thead>
    <tbody>
    <AttachableTableRowComponent
        v-for="attachable in attachables"
        :key="attachable.id"
        :attachable="attachable"
    >
    </AttachableTableRowComponent>
    </tbody>
  </table>
</template>
<script>
import AttachableTableRowComponent from "./TableRowComponent";

export default {
  name: "AttachableTableComponent",
  props: {
    attachables: {
      type: Array,
      required: true
    }
  },
  components: {
    AttachableTableRowComponent,
  },
  data() {
    return {
      editing: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
    }
  },
}
</script>

<style scoped>

</style>
